import React from 'react';

import {
  BaseMatterNote,
  IncidentNote,
  NOTE_TYPES,
} from '@/services/types/matter-notes-types';
import { MedicalProvider } from '@/services/types/treatment-types';

import { MatterNoteConfig } from '../types';
import { BaseMatterNoteForm } from './BaseMatterNoteForm';
import { IncidentNoteForm } from './IncidentNoteForm';
import { MedicalProviderNoteForm } from './MedicalProviderNoteForm';

export interface MatterNoteFormProps {
  config: MatterNoteConfig;
  matterId: string;
  note?: BaseMatterNote | null;
  onSaved?: (note: BaseMatterNote) => void;
  onCancelled?: () => void;
  onDeleted?: () => void;
}

export const MatterNoteForm: React.FC<MatterNoteFormProps> = (props) => {
  const { config } = props;

  // Use specialized note components based on note type
  switch (config.type) {
    case NOTE_TYPES.INCIDENT: {
      const { note, ...restProps } = props;
      return <IncidentNoteForm {...restProps} note={note as IncidentNote} />;
    }
    case NOTE_TYPES.MEDICAL: {
      const { note, ...restProps } = props;
      return (
        <MedicalProviderNoteForm
          {...restProps}
          note={note as MedicalProvider}
        />
      );
    }
    default: {
      const { note, ...restProps } = props;
      return <BaseMatterNoteForm {...restProps} note={note} />;
    }
  }
};
